import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/melissa/NodeProjects/thelaunchmarket/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/melissa/NodeProjects/thelaunchmarket/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/melissa/NodeProjects/thelaunchmarket/src/components/Footer/Footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/melissa/NodeProjects/thelaunchmarket/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/melissa/NodeProjects/thelaunchmarket/src/styles/globals.css");
